import { useState, useEffect } from "react";
import api from "../services/api";

const MESES_NOME = ["", "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

export default function Parametros() {
  const [params, setParams] = useState(null);
  const [dsr, setDsr] = useState([]);
  const [anoFiltro, setAnoFiltro] = useState(new Date().getFullYear());
  const [savedParams, setSavedParams] = useState(false);
  const [editando, setEditando] = useState(null);   // { id, domingos_feriados, total_dias, dias_uteis }
  const [gerandoAno, setGerandoAno] = useState(false);
  const [novoAno, setNovoAno] = useState(new Date().getFullYear() + 1);
  const [msgDsr, setMsgDsr] = useState("");

  const loadDsr = (ano) =>
    api.get(`/parametros/dsr?ano=${ano}`).then(({ data }) => setDsr(data));

  useEffect(() => {
    api.get("/parametros/financeiros").then(({ data }) => setParams(data)).catch(() => {});
    loadDsr(anoFiltro);
  }, [anoFiltro]);

  // ── Parâmetros financeiros ──────────────────────────────────────────────
  const saveParams = async (e) => {
    e.preventDefault();
    await api.put("/parametros/financeiros", params);
    setSavedParams(true);
    setTimeout(() => setSavedParams(false), 3000);
  };

  // ── DSR: salvar linha editada ───────────────────────────────────────────
  const salvarLinha = async (row) => {
    await api.put("/parametros/dsr", {
      ano: row.ano,
      mes: row.mes,
      domingos_feriados: parseInt(editando.domingos_feriados),
      total_dias: parseInt(editando.total_dias),
      dias_uteis: parseInt(editando.dias_uteis),
    });
    setEditando(null);
    loadDsr(anoFiltro);
    setMsgDsr("Mês atualizado com sucesso!");
    setTimeout(() => setMsgDsr(""), 3000);
  };

  // ── DSR: gerar ano completo ─────────────────────────────────────────────
  const gerarAno = async () => {
    setGerandoAno(true);
    try {
      await api.post(`/parametros/dsr/gerar/${novoAno}?sobrescrever=false`);
      setAnoFiltro(novoAno);
      setMsgDsr(`Calendário ${novoAno} gerado (base: domingos). Edite para incluir feriados.`);
      setTimeout(() => setMsgDsr(""), 6000);
    } catch (err) {
      setMsgDsr(err.response?.data?.detail || "Erro ao gerar");
    } finally {
      setGerandoAno(false);
    }
  };

  const fields = [
    ["taxa_impostos", "Taxa Impostos", "19,75%"],
    ["taxa_desp_comercial", "Taxa Desp. Comercial", "7,70%"],
    ["taxa_desp_administrativa", "Taxa Desp. Administrativa", "24,99%"],
    ["taxa_socios", "Taxa Sócios (informativo)", "18,63%"],
    ["taxa_lucro_esperado", "Taxa Lucro Esperado", "5,00%"],
    ["taxa_fgts", "Taxa FGTS", "8,00%"],
    ["valor_unitario_trienio_padrao", "Valor Unit. Triênio Padrão (R$)", "R$ 124,25"],
    ["limite_inss", "Limite INSS — Produtividade (R$)", "R$ 8.000,00"],
    ["percentual_repasse_resultado_positivo", "% Repasse s/ Resultado Positivo", "ex: 0.40 = 40% (entre 0 e 1)", 0.0001],
    ["limite_repasse", "Limite de % de Repasse ao Vendedor", "ex: 5 = máx 5%"],
  ];

  return (
    <div>
      <h4 className="fw-bold mb-4">Parâmetros Financeiros</h4>

      {/* ── Parâmetros financeiros ── */}
      {savedParams && <div className="alert alert-success">Parâmetros salvos!</div>}
      {params && (
        <div className="card mb-4">
          <div className="card-header fw-bold">Taxas e Encargos</div>
          <div className="card-body">
            <form onSubmit={saveParams} className="row g-3">
              {fields.map(([key, label, hint]) => (
                <div key={key} className="col-md-4">
                  <label className="form-label">
                    {label} <small className="text-muted">({hint})</small>
                  </label>
                  <input type="number" step="0.0001" className="form-control"
                    value={params[key] ?? ""}
                    onChange={(e) => setParams({ ...params, [key]: parseFloat(e.target.value) })} />
                </div>
              ))}
              <div className="col-12">
                <div className="alert alert-info py-2 mb-2">
                  <strong>Limite de % de Repasse:</strong> define o teto de remuneração variável pago ao vendedor (em % da Comissão Auferida).
                  Se o % calculado ultrapassar esse limite, o vendedor recebe apenas o limite e a diferença aumenta o resultado da empresa.
                  Use <strong>100</strong> para desativar o limite (padrão).
                </div>
              </div>
              <div className="col-12">
                <button type="submit" className="btn btn-primary">Salvar Parâmetros</button>
                <small className="text-muted ms-3">
                  Uma nova versão é criada, preservando o histórico anterior.
                </small>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ── Calendário DSR ── */}
      <div className="card">
        <div className="card-header fw-bold d-flex justify-content-between align-items-center flex-wrap gap-2">
          <span>Calendário DSR</span>

          {/* Filtro de ano + Gerar novo ano */}
          <div className="d-flex gap-2 align-items-center flex-wrap">
            <select className="form-select form-select-sm" style={{ width: 90 }}
              value={anoFiltro} onChange={(e) => setAnoFiltro(parseInt(e.target.value))}>
              {[2024, 2025, 2026, 2027, 2028].map((y) => (
                <option key={y} value={y}>{y}</option>
              ))}
            </select>

            <div className="input-group input-group-sm">
              <input type="number" className="form-control" style={{ width: 80 }}
                value={novoAno}
                onChange={(e) => setNovoAno(parseInt(e.target.value))}
                min="2020" max="2100" />
              <button className="btn btn-outline-primary" onClick={gerarAno} disabled={gerandoAno}>
                {gerandoAno ? "Gerando..." : "Gerar Ano"}
              </button>
            </div>
          </div>
        </div>

        {msgDsr && (
          <div className="alert alert-info m-3 py-2 mb-0">{msgDsr}</div>
        )}

        <div className="card-body p-0">
          <table className="table table-sm table-hover mb-0">
            <thead className="table-dark">
              <tr>
                <th>Mês</th>
                <th>Dom./Feriados
                  <small className="d-block text-white-50 fw-normal">edite p/ incluir feriados</small>
                </th>
                <th>Dias Totais</th>
                <th>Dias Úteis</th>
                <th>Fator DSR</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {dsr.map((row) => {
                const isEditing = editando?.id === row.id;
                return (
                  <tr key={row.id} className={isEditing ? "table-warning" : ""}>
                    <td className="fw-semibold">{MESES_NOME[row.mes]}</td>

                    {isEditing ? (
                      <>
                        <td>
                          <input type="number" className="form-control form-control-sm" style={{ width: 80 }}
                            value={editando.domingos_feriados}
                            onChange={(e) => setEditando({ ...editando, domingos_feriados: e.target.value })} />
                        </td>
                        <td>
                          <input type="number" className="form-control form-control-sm" style={{ width: 80 }}
                            value={editando.total_dias}
                            onChange={(e) => setEditando({ ...editando, total_dias: e.target.value })} />
                        </td>
                        <td>
                          <input type="number" className="form-control form-control-sm" style={{ width: 80 }}
                            value={editando.dias_uteis}
                            onChange={(e) => setEditando({ ...editando, dias_uteis: e.target.value })} />
                        </td>
                        <td className="text-muted">—</td>
                        <td>
                          <button className="btn btn-sm btn-success me-1" onClick={() => salvarLinha(row)}>✓ Salvar</button>
                          <button className="btn btn-sm btn-secondary" onClick={() => setEditando(null)}>✕</button>
                        </td>
                      </>
                    ) : (
                      <>
                        <td>{row.domingos_feriados}</td>
                        <td>{row.total_dias}</td>
                        <td>{row.dias_uteis}</td>
                        <td>{(row.dsr_fator * 100).toFixed(3)}%</td>
                        <td>
                          <button className="btn btn-sm btn-outline-primary"
                            onClick={() => setEditando({
                              id: row.id,
                              domingos_feriados: row.domingos_feriados,
                              total_dias: row.total_dias,
                              dias_uteis: row.dias_uteis,
                            })}>
                            Editar
                          </button>
                        </td>
                      </>
                    )}
                  </tr>
                );
              })}
              {dsr.length === 0 && (
                <tr>
                  <td colSpan={6} className="text-center text-muted py-3">
                    Nenhum dado para {anoFiltro}. Use "Gerar Ano" para criar automaticamente.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="card-footer text-muted small">
          <strong>Fator DSR</strong> = Domingos/Feriados ÷ (Total − Domingos/Feriados) &nbsp;|&nbsp;
          <strong>Base gerada:</strong> apenas domingos. Adicione feriados incrementando "Dom./Feriados" e reduzindo "Dias Úteis".
        </div>
      </div>
    </div>
  );
}
